module.exports = __webpack_public_path__ + "img/3.b5d5be88.png";